import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { WorldInterface } from "../../store/mine_craft/worldsSlice";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.worldPath(value.id),
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url),
    mcworld_url: minecraftUrls.remoteUrl(value.mcworld_url)
  };
}

const worldsEntity = new schema.Entity(
  'worlds',
  {},
  {
    processStrategy
  }
);

const worldEntity = new schema.Entity(
  'world',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { world: WorldInterface }>(response.data.world, worldEntity);
  return normalized.entities;
}

export const fetchWorlds = createAsyncThunk(
  'worlds/fetchWorlds',
  async (params: object = {}) => {
    const response    = await mineCraftApi.get(`/onesky/worlds`, { params })
    const normalized  = normalize<any, { worlds: { [key: string]: WorldInterface } }>(response.data.worlds, [worldsEntity]);

    return {
      worlds: normalized.entities?.worlds || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchWorld = createAsyncThunk(
  'worlds/fetchWorld',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/worlds/${id}`);
    return normalizeInstance(response);
  }
);

export const createWorld = createAsyncThunk(
  'worlds/createWorld',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/worlds`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateWorld = createAsyncThunk(
  'worlds/updateWorld',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/worlds/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyWorld = createAsyncThunk(
  'worlds/destroyWorld',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/worlds/${id}`);
    return response.data;
  }
);
